export default "/images/53d3f9b28c346ba52b10995038b88a05.avif";